import { Card, DetailsCategoryItem, Icon, RoundElement } from 'ui';

type P = {
  medicalGroupName: string;
};

const EventDetailsCard = ({ medicalGroupName }: P) => (
  <Card title={<Card.Title icon={<Icon icon="information-line" />}>Details</Card.Title>}>
    <DetailsCategoryItem
      category="Medical group"
      icon={
        <RoundElement size="extra-small">
          <Icon color="text" icon="hospital-line" />
        </RoundElement>
      }
      name={medicalGroupName}
    />
  </Card>
);

export default EventDetailsCard;
